import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  rowDisplay: { display: 'flex', flexDirection: 'row', alignItems: 'center' },
  logo: {
    flexShrink: 0,
    minHeight: '76px !important',
    padding: '0 16px !important',
    gap: 10,
    overflow: 'hidden'
  },
  sidebarContainer: {
    backgroundColor: theme.palette.common.white,
    overflowY: 'auto',
    '&::-webkit-scrollbar': { width: 0 }
  },
  sidebarBox: {
    backgroundColor: theme.palette.common.white,
    padding: 0,
    borderRadius: 0,
    height: '100%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overscrollBehavior: 'contain',
    '&::-webkit-scrollbar': { width: 6 },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[200],
      borderRadius: 6
    }
  },
  sidebarList: {
    flexShrink: 0,
    padding: '4px 12px 24px 12px',
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },
  sidebarLink: {
    position: 'relative',
    minHeight: 42,
    backgroundColor: 'transparent',
    marginTop: 2,
    padding: '9px 12px',
    borderRadius: 10,
    color: theme.palette.text.secondary,
    transition: 'background-color .15s ease, color .15s ease',
    '& .MuiSvgIcon-root': {
      color: theme.palette.grey[600],
      transition: 'color .15s ease'
    },
    '&:hover': {
      backgroundColor: theme.palette.background.primary,
      boxShadow: 'none',
      '& .MuiSvgIcon-root': { color: theme.palette.text.primary }
    }
  },
  // Active item: raised brand pill with white label and icon.
  active: {
    backgroundColor: theme.palette.primary.main,
    backgroundImage:
      'linear-gradient(145deg, #FF9458 0%, #F4661F 55%, #D9500F 100%)',
    boxShadow:
      'inset 0 1px 0 rgba(255,255,255,0.4), inset 0 -2px 0 rgba(0,0,0,0.1), 0 8px 16px -6px rgba(244,102,31,0.55)',
    '& .MuiSvgIcon-root': {
      color: `${theme.palette.common.white} !important`
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.main
    }
  },
  blackText: {
    color: '#1F2937',
    fontWeight: 500
  },
  whiteText: {
    color: theme.palette.common.white,
    fontWeight: 600
  },
  linkText: {
    fontSize: 14,
    lineHeight: 1.2,
    paddingLeft: 12,
    marginTop: 0,
    letterSpacing: 0
  },
  headingText: {
    marginTop: 18,
    marginBottom: 6,
    marginLeft: 12,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: theme.palette.grey[500]
  },
  logoText: {
    fontWeight: 800,
    paddingLeft: 0,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    fontSize: 22,
    letterSpacing: '-0.01em',
    textTransform: 'none',
    color: theme.palette.text.primary
  },
  restContainer: {
    margin: '4px 12px 8px 12px',
    padding: '10px 12px',
    backgroundColor: theme.palette.background.primary,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
    gap: 10
  },
  restText: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.primary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  restImage: {
    borderRadius: 8,
    marginRight: 0,
    objectFit: 'cover'
  },
  sidebarDivider: {
    margin: '12px 12px 0 12px',
    borderColor: theme.palette.divider
  }
}))

export default useStyles
